import { render } from "./limit.vue?vue&type=template&id=8cea87f8&lang=html"
import script from "./limit.vue?vue&type=script&lang=js"
export * from "./limit.vue?vue&type=script&lang=js"

import "./limit.vue?vue&type=style&index=0&id=8cea87f8&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__